import React from 'react';
import XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';

export function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

// check param[email] exist in param[list] and render respected Icon
export function renderIncludedOrNot(email, list = []) {
    const isIncluded = list.includes(email)
    if (isIncluded) return <FontAwesomeIcon color='green' icon={faCheck} />
    return <FontAwesomeIcon color='red' icon={faTimes} />
}

// required param[e]: Event Input
// required param[sheet_to]: enter on of XLSX Utility function
// ['sheet_to_csv', sheet_to_json','sheet_to_html','sheet_to_text']
export async function onUploadXLSX(e, sheet_to) {
    return new Promise(resolve => {
        var file = e.target.files[0];
        if (!file) return;
        var reader = new FileReader();
        // Ready The Event For When A File Gets Selected
        reader.onload = function (e) {
            var data = e.target.result;
            // read to binary
            const wb = XLSX.read(data, { type: "binary" });
            // take the first sheet
            const wn = wb.SheetNames[0];
            const ws = wb.Sheets[wn];
            const parsed = XLSX.utils[sheet_to](ws);

            console.log('parsed', parsed)
            resolve(parsed)
        };
        // Tell JS To Start Reading The File.. You could delay this if desired
        reader.readAsBinaryString(file);
    })

}